import React, { useState } from "react";

const CONTACT = "rafeelshayy.rs@gmail.com";
const YEAR    = new Date().getFullYear();

const TERMS = `
BEYOND THE BODY — TERMS AND CONDITIONS
Last updated: June ${YEAR}

1. ABOUT US
Beyond The Body is a digital wellness platform operating at beyondthebody.co.tz, offering guided meditation and personal transformation programs.

2. ACCEPTANCE OF TERMS
By enrolling in any program and completing payment, you confirm that you are at least 18 years old and agree to these Terms in full.

3. PROGRAMS AND ACCESS
Upon successful payment, you receive access to your enrolled program for the duration specified at the time of purchase (lifetime access or subscription period). Program content — audio, video, and written material — is for your personal use only and may not be shared, copied, or redistributed. We reserve the right to update program content to improve quality.

4. PAYMENTS
All payments are processed securely via AzamPay mobile money (M-Pesa, Tigo Pesa, Airtel Money, Halo Pesa). Prices are listed in Tanzanian Shillings (TZS) and are inclusive of any applicable taxes. Payment is due at the time of enrollment. Access is granted once payment is confirmed.

5. REFUND POLICY
Due to the digital nature of our programs, all sales are final. No refunds are issued once payment is made. If you experience a technical issue preventing access, contact us within 7 days at ${CONTACT} and we will resolve it.

6. COACH INTERACTION
Coaches may respond to journal entries and provide feedback. Coaching is for motivational and wellness purposes only and does not constitute medical, psychological, or therapeutic advice.

7. HEALTH DISCLAIMER
Our programs are for general wellness and personal development. They are not a substitute for professional medical or mental health treatment. Consult a qualified health professional before starting any wellness program if you have a medical condition.

8. YOUR ACCOUNT
You are responsible for keeping your login credentials secure. Do not share your account with others.

9. INTELLECTUAL PROPERTY
All content on this platform — including program audio, video, text, and design — is owned by Beyond The Body and protected by copyright. Unauthorised use is prohibited.

10. LIMITATION OF LIABILITY
To the extent permitted by law, Beyond The Body shall not be liable for any indirect or consequential loss arising from use of the platform.

11. GOVERNING LAW
These Terms are governed by the laws of the United Republic of Tanzania.

12. CONTACT
For any questions: ${CONTACT}
`.trim();

const PRIVACY = `
BEYOND THE BODY — PRIVACY POLICY
Last updated: June ${YEAR}

1. WHAT WE COLLECT
When you use our platform, we collect:
• Account information — name and email address (authentication is handled securely by Google Firebase)
• Phone number — provided when making a payment
• Payment information — transaction reference, amount, and mobile network operator (processed by AzamPay; we do not store your mobile money PIN or account credentials)
• Wellness assessment responses — your answers to the pre-enrollment questionnaire
• Journal entries — reflections you write within the program
• Usage data — which sessions you have completed and your progress

2. HOW WE USE YOUR DATA
• To provide and manage your access to enrolled programs
• To process payments via AzamPay
• To allow your coach to review your journal entries and provide feedback
• To send you important updates about your program
• To improve our platform and content

3. WHO WE SHARE DATA WITH
We do not sell your personal data. We share it only with:
• Google Firebase — our platform infrastructure (authentication, database, file storage). Firebase operates under Google's privacy standards.
• AzamPay — our payment processor, for the purpose of processing your mobile money payment. AzamPay's own privacy policy applies to payment data they handle.

4. DATA STORAGE AND SECURITY
Your data is stored securely on Google Firebase servers. We implement appropriate technical measures to protect your information from unauthorised access.

5. DATA RETENTION
We retain your account and program data for as long as your account is active. If you request deletion of your account, we will remove your personal data within 30 days, except where required for legal or financial record-keeping purposes.

6. YOUR RIGHTS
You have the right to access, correct, or request deletion of your personal data. To exercise any of these rights, contact us at ${CONTACT}.

7. CHILDREN'S PRIVACY
Our platform is not intended for anyone under the age of 18. We do not knowingly collect data from minors.

8. CHANGES TO THIS POLICY
We may update this policy from time to time. We will notify registered users of any significant changes by email.

9. CONTACT
For privacy-related questions: ${CONTACT}
`.trim();

export function LegalModal({ defaultTab = "terms", onClose }) {
  const [tab, setTab] = useState(defaultTab);

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
      zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center",
      padding: "16px",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "#F2F6F7", borderRadius: 16, maxWidth: 620, width: "100%",
        maxHeight: "85vh", display: "flex", flexDirection: "column",
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
      }}>
        {/* Header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "20px 24px 0", flexShrink: 0,
        }}>
          <div style={{ display: "flex", gap: 8 }}>
            {[["terms", "Terms & Conditions"], ["privacy", "Privacy Policy"]].map(([key, label]) => (
              <button key={key} onClick={() => setTab(key)} style={{
                background: tab === key ? "#1F4E5A" : "transparent",
                color: tab === key ? "#F2F6F7" : "#1F4E5A",
                border: `1px solid #1F4E5A`, borderRadius: 20,
                padding: "6px 14px", fontSize: 13, cursor: "pointer",
                fontFamily: "'Inter', sans-serif",
              }}>{label}</button>
            ))}
          </div>
          <button onClick={onClose} style={{
            background: "none", border: "none", fontSize: 22, cursor: "pointer",
            color: "#1F4E5A", lineHeight: 1, padding: "0 4px",
          }}>×</button>
        </div>

        {/* Body */}
        <div style={{
          overflowY: "auto", padding: "20px 24px 28px",
          fontFamily: "'Inter', sans-serif", fontSize: 13.5, lineHeight: 1.8,
          color: "#1E2E33", whiteSpace: "pre-wrap",
        }}>
          {tab === "terms" ? TERMS : PRIVACY}
        </div>
      </div>
    </div>
  );
}

export function LegalLinks({ style = {} }) {
  const [modal, setModal] = useState(null);
  return (
    <>
      <span style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", ...style }}>
        <button onClick={() => setModal("terms")} style={{
          background: "none", border: "none", padding: 0, color: "#9FCAD2",
          textDecoration: "underline", textUnderlineOffset: 3, cursor: "pointer", fontSize: "inherit", fontFamily: "inherit", fontWeight: 500,
        }}>Terms & Conditions</button>
        {" · "}
        <button onClick={() => setModal("privacy")} style={{
          background: "none", border: "none", padding: 0, color: "#9FCAD2",
          textDecoration: "underline", textUnderlineOffset: 3, cursor: "pointer", fontSize: "inherit", fontFamily: "inherit", fontWeight: 500,
        }}>Privacy Policy</button>
      </span>
      {modal && <LegalModal defaultTab={modal} onClose={() => setModal(null)} />}
    </>
  );
}
